<ng-container *ngIf="options">
    <ng-container *ngIf="isCrawler; else elseBlock">
        <picture>
            <source *ngFor="let source of sourceImages; index as i" [attr.media]="minWidthMedia(source.minWidth)"
                [attr.srcset]="sourceSetDensity(source, 5)" />
            <img [src]="sourceSetDensity(defaultImage, 1)" [attr.srcset]="sourceSetDensity(defaultImage, 5, 2)"
                [attr.alt]="options.alt" class="prerendered" />
        </picture>
    </ng-container>
    <ng-template #elseBlock>
        <img *ngIf="currentImage$ | async as eImage" [src]="eImage" [ngClass]="{ prerendered: showImage$ | async }"
            (lazyCall)="intersectionObserver()" [lazyLoad]="options?.lazyLoadOptions" [attr.alt]="options.alt" />
    </ng-template>
</ng-container>
